
import { ActionIdEnum } from "src/app/core/enums/list-layout/action-id-enum";
import { ButtonIdEnum } from "src/app/core/enums/list-layout/button-id-enum";
import { ButtonTypeEnum } from "src/app/core/enums/list-layout/button-type-enum";
import { ColumnTypeEnum } from "src/app/core/enums/list-layout/column-type-enum";
import { GlobalComponent } from "src/app/global-component";
import { TableConfigurationModel } from "src/app/core/models/table/table-configuration.model";
import { SortByValuesModel } from "src/app/core/models/table/sort-by-values.model";
import { NgSelectListModel } from "src/app/core/models/ng-select-list.model";
import { DocumentStatus } from "src/app/core/models/document/document-template-model";
import { CustomDateDisplayEnum } from "src/app/core/enums/list-layout/custom-date-display-enum";


export class BillingListConfig extends TableConfigurationModel {

    constructor() {
        super();
        this.canConfigBeSavedToServer = true;
        this.listTitle = "Billing History";
        this.pageSizeFilter = [
            { pageSize: GlobalComponent.defaultPagingInfo.pageSize },
            { pageSize: GlobalComponent.defaultPagingInfo.pageSizeLG },
            { pageSize: GlobalComponent.defaultPagingInfo.pageSizeXL },
            { pageSize: GlobalComponent.defaultPagingInfo.exportPageSize },
        ]
        this.displayTabulation = true;
        this.columns = [
            {
                visible: 'true',
                order: 0,
                width: "15px",
                type: ColumnTypeEnum.CheckBox,
            },
            {

                dataFieldName: 'number',
                title: 'Invoice',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 1,
                width: "180px",
                type: ColumnTypeEnum.PhotoModel,
                imageUrlLink: true,
                tabulationTitle: 'Totals:',
                tabulate: true,
                tabulationPlaceHolder:true,
            },
            {
                dataFieldName: 'requisition',
                title: 'Requisition #',
                sortable: new SortByValuesModel('createdDate'),
                visible: 'true',
                order: 2,
                width: "220px",
                type: ColumnTypeEnum.SubPhotoModel,
                subDataFieldName:'number',
                underTextDataFieldName: 'type',
                imageUrlLink: true
            },

            {
                dataFieldName: 'client',
                title: 'Client',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 3,
                width: "180px",
                type: ColumnTypeEnum.SubPhotoModel,
                subDataFieldName: 'fullName',
                underTextDataFieldName: 'matterNumber'
            },
            {
                dataFieldName: 'account',
                title: 'Contact',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 4,
                width: "180px",
                type: ColumnTypeEnum.SubPhotoModel,
                subDataFieldName: 'fullName',
                underTextDataFieldName: 'companyName'

            },
            {
                dataFieldName: 'requisition',
                title: 'Matter number',
                visible: 'true',
                sortable: undefined,
                order: 5,
                width: "180px",
                type: ColumnTypeEnum.ValueInSubModel,
                subDataFieldName: 'matterNumber',
            },
             {
                dataFieldName: 'claimNumber',
                title: 'Claim number',
                visible: 'true',
                sortable: undefined,
                order: 6,
                width: "180px",
                type: ColumnTypeEnum.String,
                subDataFieldName: 'claimNumber',
            },
            //   {
            //     dataFieldName: `lineItems`,
            //     title: `Description`,
            //     visible: 'true',
            //     sortable: undefined,
            //     order: 4,
            //     width: "180px",
            //     type: ColumnTypeEnum.ValueInArrayFirstIndex,
            //     subDataFieldName: `description`,
            // },
            {

                dataFieldName: 'price',
                title: `Contact's fee`,
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 7,
                width: "180px",
                type: ColumnTypeEnum.Amount,
                imageUrlLink: true,
                tabulate: true,
                tabulationTitle: '$'
            },
            {

                dataFieldName: 'processingFee',
                title: 'Processing Fee',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 8,
                width: "180px",
                type: ColumnTypeEnum.Amount,
                imageUrlLink: true,
                tabulate: true,
                tabulationTitle: '$'
            },
            {

                dataFieldName: 'hst',
                title: 'Tax',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 9,
                width: "180px",
                type: ColumnTypeEnum.Amount,
                imageUrlLink: true,
                tabulate: true,
                tabulationTitle: '$'
            },
            {

                dataFieldName: 'total',
                title: 'Total',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 10,
                width: "180px",
                type: ColumnTypeEnum.Amount,
                imageUrlLink: true,
                tabulate: true,
                tabulationTitle: '$'
            },
        {
                dataFieldName: 'modifiedDate',
                title: 'Last Modified',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 11,
                width: "120px",
                type: ColumnTypeEnum.Date,
                customDateDisplayOptionSelected: CustomDateDisplayEnum.YMD_Slashes,
            },
            {
                title: 'Actions',
                visible: 'true',
                order: 12,
                width: "125px",
                type: ColumnTypeEnum.Action 
            },
        ]
        this.searchbarFilter =
        {
            value: '',
            placeHolderText: "Search by invoice number, client, contact, matter number, etc."
        }
        this.dateFilter =
        {
            dateRange: undefined,
        }

        this.filters = [ {  
                        label: 1,
                        options: [  
                            new NgSelectListModel(undefined, $localize`:@@:Select Status`,$localize`:@@:Select Status`,undefined, true ),
                            new NgSelectListModel(DocumentStatus.Approved, $localize`:@@:Approved`, $localize`:@@:Approved` ),
                            new NgSelectListModel(DocumentStatus.Completed, $localize`:@@:Completed`, $localize`:@@:Completed` ),      
                        ],
                        selectedOption: undefined,
                        inDropdown: true,
                        inHeading: false,
                        inButton: false,
                    }];

        this.actions = [
            {
                visible: 'true',
                label: 'View',
                actionId: ActionIdEnum.View,
                icon: 'ri-eye-fill',
                inDropdown: true,
                inList: true
            },
            {
                visible: 'true',
                label: 'Download',
                actionId: ActionIdEnum.Download,
                icon: 'ri-file-download-line',
                inDropdown: true,
                inList: true
            },
        ]
   
        this.buttons = [
            {
                visible: 'true',
                label: "Export",
                action: ButtonIdEnum.None,
                color: "btn-soft-info",
                iconIsAfterLabel: true,
                icon: "ri-more-2-fill",
                type: ButtonTypeEnum.Dropdown,
                actions: [
                    {
                        text: $localize`:@@Export_Excel:Export to Excel`,
                        value: `${ButtonIdEnum.ExportExcel}`,
                        color: 'btn-soft-primary',
                        visible: `true`
                    },
                    {
                        text:  $localize`:@@Export_CSV:Export to CSV`,
                        value: `${ButtonIdEnum.ExportCSV}`,
                        color: 'btn-soft-primary',
                        visible: `true`
                    },
           
                ]
            },

        ]
    }
}